import * as tslib_1 from "tslib";
import * as React from 'react';
import { StyledIconBase } from '../../StyledIconBase';
export var Megaphone = React.forwardRef(function (props, ref) {
    var attrs = {
        "fill": "currentColor",
    };
    return (React.createElement(StyledIconBase, tslib_1.__assign({ iconAttrs: attrs, iconVerticalAlign: "middle", iconViewBox: "0 0 24 24" }, props, { ref: ref }),
        React.createElement("path", { d: "M7.562 19.18c.223.536.665.949 1.216 1.133l4.084 1.361a2.015 2.015 0 0 0 2.421-1.003l1.303-2.606L22 20V3L8 8v7l.748.267-1.127 2.254a1.995 1.995 0 0 0-.059 1.659zm3.084-3.235l4.042 1.444-1.194 2.388-4.084-1.361 1.236-2.471zM4 15h2V8H4c-1.103 0-2 .897-2 2v3c0 1.103.897 2 2 2z", key: "k0" })));
});
Megaphone.displayName = 'Megaphone';
export var MegaphoneDimensions = { height: 24, width: 24 };
